import ReportGenerator from "./report_generator";
import {
    AREA_DATA_FIELD,
    BAR_CHART,
    BUILDING_DATA_FIELD,
    COST_DATA_FIELD,
    COUNT_FIELD,
    DEPLOYMENT_STATUS_FIELD,
    ROOM_DATA_FIELD,
    TOTAL_COST_FIELD,
    TOTAL_DEVICES_REPORT_TITLE,
    UPDATED_AT_DATA_FIELD
} from "../../constants/reports_constants";

export default class TotalDevicesReportGenerator extends ReportGenerator {

    _getGraphTitle() {
        return TOTAL_DEVICES_REPORT_TITLE;
    }

    _hideUnusedColumns() {
        this._hideColumn(COST_DATA_FIELD);
        this._hideColumn(COUNT_FIELD);
        this._hideColumn(DEPLOYMENT_STATUS_FIELD);
        this._hideColumn(TOTAL_COST_FIELD);
        this._hideColumn(UPDATED_AT_DATA_FIELD);
    }

    _showUsedColumns() {
        this._showColumn(BUILDING_DATA_FIELD);
        this._showColumn(AREA_DATA_FIELD);
        this._showColumn(ROOM_DATA_FIELD);
    }

    _getChartType() {
        return BAR_CHART;
    }

    /**
     * Get filter function to exclude bundle component items
     * 
     * For bundle instances, only show ONE row per bundle_instance_id (deduplicate).
     * This prevents multiple rows for the same bundle from appearing in the report.
     * 
     * @returns {Function} Filter function
     * @protected
     */
    _getFilterFunction() {
        // Track which bundle instances we've already seen
        const seenBundleInstances = new Set();
        
        return (item) => {
            // If item doesn't have a bundle_instance_id, it's a standalone item - include it
            if (!item.bundle_instance_id) {
                return true;
            }
            
            // For bundle instances, only include the first occurrence
            const bundleKey = `${item.bundle?.id || 'unknown'}_${item.bundle_instance_id}`;
            
            if (seenBundleInstances.has(bundleKey)) {
                // We've already seen this bundle instance - exclude it
                return false;
            }
            
            // First time seeing this bundle instance - include it and mark as seen
            seenBundleInstances.add(bundleKey);
            return true;
        };
    }

}